import api from 'util/api';
import { printAsPDF } from 'util/misc';

function formatNote(note) {
  return `${note.noteText}\n\n- ${note.createdBy} ${new Date(note.createdAt).toLocaleString()}`;
}

function printNotesForMultipleDevices(devices) {
  const allNotes = [];
  async function fetchNotes(device) {
    try {
      const res = await api(`/devices/${device.id}/notes`);
      const data = await res.json();
      allNotes.push([device.name, ...data.map(formatNote)].join('\n\n\n'));
    } catch (error) {

    }
  }
  Promise.all(devices.map(fetchNotes))
    .then(() => {
      printAsPDF(allNotes.join('\n\n\n _________________________ \n\n\n'));
    });
}

export { formatNote, printNotesForMultipleDevices };
